<template>
  <core-etapa5 />
</template>

<script>

export default {
  components: {
    CoreEtapa5: () => import('@/components/core/Etapa5')
  }
}
</script>
